jQuery(function () {
  const domReady = (cb) => {
    if (typeof wp !== "undefined" && wp.domReady) wp.domReady(cb);
    else cb();
  };

  const once = (eventName, cb) => {
    document.addEventListener(eventName, cb, { once: true });
  };

  const whenGsapReady = (cb) => {
    if (window.gsap) return cb();
    once("longevity:gsap-ready", cb);
  };

  const whenScrollReady = (cb) => {
    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };
    once("longevity:scroll-ready", runOnce);
    setTimeout(runOnce, 0);
  };

  const isEditor =
    document.body.classList.contains("block-editor-page") ||
    document.body.classList.contains("wp-admin");

  domReady(() => {
    if (isEditor) return;
    whenGsapReady(() => {
      whenScrollReady(() => {
        initEpiStudies();
      });
    });
  });

  function initEpiStudies() {
    const blocks = document.querySelectorAll(".js-epi-studies");
    if (!blocks.length) return;

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    const gsap = window.gsap;
    if (!gsap) return;

    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
      null;

    if (ScrollTrigger && gsap.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (e) {}
    }

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    blocks.forEach((block) => {
      if (block.dataset.epiInit === "1") return;
      block.dataset.epiInit = "1";

      const items = Array.from(block.querySelectorAll(".js-epi-item"));
      const parallaxTarget = block.querySelector(".js-epi-parallax");

      const strengthAttr = block.getAttribute("data-parallax");
      const strength = strengthAttr ? parseFloat(strengthAttr) : 240;

      const speedAttr = block.getAttribute("data-parallax-speed");
      const speed = speedAttr ? parseFloat(speedAttr) : 0.8;
      const factor = clamp(1 - speed, 0, 1);

      const computeOffset = (progress) => {
        const p = clamp(progress, 0, 1);
        const t = (p - 0.5) * 2;
        return -(t * strength * factor);
      };

      const computeProgressNow = () => {
        const rect = block.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const total = rect.height + vh;
        return clamp((vh - rect.top) / total, 0, 1);
      };

      const applyOffset = (progress) => {
        if (!parallaxTarget) return;
        const off = computeOffset(progress);
        block.style.setProperty("--epi-offset", `${off}px`);
      };

      // Set initial offset BEFORE we show the small image (prevents "jump")
      if (parallaxTarget) {
        applyOffset(computeProgressNow());
        block.classList.add("is-parallax-ready");
      }

      if (reduceMotion) {
        if (items.length) {
          gsap.set(items, { autoAlpha: 1, y: 0, clearProps: "transform" });
        }
        if (parallaxTarget) {
          block.style.setProperty("--epi-offset", "0px");
          block.classList.add("is-parallax-ready");
        }
        return;
      }

      // Reveal
      if (items.length) {
        gsap.set(items, { autoAlpha: 0, y: 18 });
        const vars = {
          autoAlpha: 1,
          y: 0,
          duration: 0.95,
          ease: "power3.out",
          stagger: 0.08,
          clearProps: "transform",
        };
        if (ScrollTrigger) {
          vars.scrollTrigger = {
            trigger: block,
            start: "top 78%",
            once: true,
            invalidateOnRefresh: true,
          };
        }
        gsap.to(items, vars);
      }

      // Parallax scrub
      if (!parallaxTarget) return;

      if (ScrollTrigger) {
        const st = ScrollTrigger.create({
          trigger: block,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          invalidateOnRefresh: true,
          onUpdate: (self) => applyOffset(self.progress),
          onRefresh: (self) => applyOffset(self.progress),
        });
        applyOffset(st.progress);
        return;
      }

      // Fallback without ScrollTrigger
      let ticking = false;
      const update = () => {
        ticking = false;
        applyOffset(computeProgressNow());
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
      update();
    });
  }
});

